import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

export default function NewsCard({ news, layout = "vertical" }: { news: NewsItem; layout?: "vertical" | "horizontal" }) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/detail/${news.id}`}
        className="group flex gap-4 bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-32 sm:w-44 shrink-0 aspect-[8/5] overflow-hidden bg-background-100">
          <img
            src={news.cover}
            alt={`${news.title} 资讯封面`}
            title={`${news.title} 动漫资讯`}
            className="w-full h-full object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex flex-col py-3 pr-4 min-w-0">
          <div className="flex items-center gap-2 text-xs">
            <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700">{news.category}</span>
            <span className="text-foreground-500">{news.date}</span>
          </div>
          <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {news.title}
          </h3>
          <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 line-clamp-2 hidden sm:block">
            {news.summary}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${news.id}`}
      className="group flex flex-col bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
    >
      <div className="w-full aspect-[8/5] overflow-hidden bg-background-100">
        <img
          src={news.cover}
          alt={`${news.title} 资讯封面`}
          title={`${news.title} 动漫资讯`}
          className="w-full h-full object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex flex-col flex-1 p-4">
        <div className="flex items-center gap-2 text-xs">
          <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700">{news.category}</span>
          <span className="text-foreground-500">{news.date}</span>
        </div>
        <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {news.title}
        </h3>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-3">{news.summary}</p>
        <span className="mt-auto pt-3 text-xs text-foreground-500 flex items-center gap-1">
          <i className="ri-user-line" />
          {news.author}
        </span>
      </div>
    </Link>
  );
}